<template>
  <div class="thailand-info">
    <!--收发通信息/货物信息/运输信息/其他信息-->
    <div style="width: fit-content">
      <div style="display: flex">
        <!--收发通信息-->
        <thailand-address-format-form
          :job="job"
          :readonly="readonly"
          :address-form="afrAddress"
          @showSenderAndReceiverDialog="showSenderAndReceiverDialog"
        />
        <!--货物信息-->
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="112px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.CargoInformation')">{{ getItemTitle('Cargo Information') }}</span>
            <el-form-item :label="getItemTitle('HB/L NO')" :title="$t('SeaExport.HBLNumber')">
              <el-input v-model="form.hblNbr2" @input="hblNbr2Change" />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.BillOfLadingQuantity')" :label="getItemTitle('Quantity')">
              <auto-number-input v-model="form.quantity" :precision="0" :min="0" />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Packing')" label="Unit Type">
              <span slot="label">
                <el-tooltip :content="$t('CargoMsg.Cargo_AmsUnitTypeTip')" placement="right-end">
                  <i class="el-icon-question" style="cursor: pointer;color: #1F75D5;" />
                </el-tooltip>
                {{ getItemTitle('Unit Type') }}
              </span>
              <cargo-packing-select :default-value="form.packing" style="width:100%;" @change="changeUnitType" />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.GrossWeight')" :label="getItemTitle('Gross Weight')">
              <div style="display: flex">
                <el-input-number
                  v-model="form.weight"
                  :precision="3"
                  :controls="false"
                  style="flex: 1"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Cubage')" :label="getItemTitle('Volume')">
              <div style="display: flex">
                <el-input-number
                  v-model="form.cubage"
                  :precision="3"
                  :controls="false"
                  style="flex: 1"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item title="Container Status" label="Container Status">
              <el-select v-model="form.containerStatus" :clearable="false" @change="changeContainerStatus">
                <el-option value="4" label="4.MTY (Empty)" />
                <el-option value="7" label="7.LCL (Less Container Load)" />
                <el-option value="8" label="8.FCL (Full Container Load)" />
                <el-option value="9" label="9.CFS (Container Freight Station)" />
              </el-select>
            </el-form-item>
            <el-form-item :label="getItemTitle('Place of Receipt')" :title="$t('SeaExport.BillLadingPlaceOfDispatch')">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode"
                tag-name="englishName"
                style="flex:1"
                @parentCallBack="p => { portChange(p, 'dispatchingPlaceCode', 'dispatchingPlace') }"
              />
              <el-input v-model="form.dispatchingPlace" disabled />
            </el-form-item>
            <el-form-item
              :label="getItemTitle('Place of Delivery')"
              :title="$t('SeaExport.BillLadingPlaceOfDelivery')"
            >
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode || ''"
                tag-name="englishName"
                @parentCallBack="p => { portChange(p, 'destinationPortCode', 'destinationPort') }"
              />
              <el-input v-model="form.destinationPort" disabled />
            </el-form-item>
            <el-form-item label-width="0" :title="$t('SeaExport.Remarks')"><span>{{ getItemTitle('Remark (max 300 letters)') }}</span></el-form-item>
            <el-form-item class="auto-width" label-width="0">
              <el-input v-model="form.remarks" :maxlength="300" :disabled="!isEdit" type="textarea" :rows="5" />
            </el-form-item>
            <el-form-item label-width="0">
              <span>{{ getItemTitle('Description of Goods') }}</span>
            </el-form-item>
            <el-form-item class="auto-width" label-width="0">
              <cargo-rich-textarea
                v-model="form.cargoEnglishName"
                :disabled="!isEdit"
                :text-chars="0"
                :warning-count="512"
                :is-trim="true"
                wrap-symbol="r"
                auto-uppercase
                auto-half-word
                style="height: 110px"
              />
            </el-form-item>
            <el-form-item title="Cargo Type" label="Cargo Type">
              <el-select v-model="form.docCargoType" :clearable="false" @change="changeCargoType">
                <el-option value="1" label="1. General" />
                <el-option value="2" label="2. Dangerous" />
                <el-option value="7" label="7. Reefer Cargo" />
              </el-select>
            </el-form-item>
            <el-form-item label="UNDG Number" title="UNDG Number">
              <el-input v-model="form.undgNumber" />
            </el-form-item>
            <el-form-item label="IMO Class" title="IMO Class">
              <el-input v-model="form.imoClass" />
            </el-form-item>
          </el-form>
        </div>
        <!--运输信息-->
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="116px" label-position="right" style="height:100%">
            <span class="title" :title="$t('SeaExport.TransportationInformation')">{{ getItemTitle('Shipping Information') }}</span>
            <el-form-item :label="getItemTitle('MB/L NO')" :title="$t('SeaExport.MBLNumber')">
              <el-input v-model="form.mbl" @change="$emit('syncThailandInfo', 'mbl')" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Vessel')" :title="$t('SeaExport.ShipName')">
              <el-input v-model="form.vessel" @change="$emit('syncThailandInfo', 'vessel')" />
            </el-form-item>
            <el-form-item :label="getItemTitle('Voyage')" :title="$t('SeaExport.Voyage')">
              <cargo-rich-textarea
                v-model="form.voyageFlight"
                :disabled="readonly"
                :text-chars="0"
                :warning-count="10"
                :is-trim="true"
                style="min-height: unset;"
                @change="changeVoyage"
              />
            </el-form-item>
            <el-form-item :label="getItemTitle('IMO')" :title="$t('SeaExport.ShipNumber')">
              <el-input v-model="form.vesselIMO" @change="$emit('syncThailandInfo', 'vesselIMO')" />
            </el-form-item>
            <el-form-item
              :label="getItemTitle('Call Sign')"
              :title="$t('SeaExport.BookingShipCallSign')"
            >
              <el-input v-model="form.vesselCode" @change="$emit('syncThailandInfo', 'vesselCode')" />
            </el-form-item>
            <el-form-item :label="getItemTitle('ETD')" :title="$t('SeaExport.DateOfDeparture')">
              <el-date-picker
                v-model="form.etd"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%;"
                @change="$emit('syncThailandInfo', 'etd')"
              />
            </el-form-item>
            <el-form-item :label="getItemTitle('ETA')" :title="$t('SeaExport.ArrivalDate')">
              <el-date-picker
                v-model="form.eta"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%;"
                @change="$emit('syncThailandInfo', 'eta')"
              />
            </el-form-item>
            <el-form-item
              :label="getItemTitle('Place of Loading')"
              :title="$t('SeaExport.BillLadingPortOfDeparture')"
            >
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode || ''"
                tag-name="englishName"
                @parentCallBack="p => { portChange(p, 'loadingPortCode', 'loadingPort') }"
              />
              <el-input v-model="form.loadingPort" disabled />
            </el-form-item>
            <el-form-item
              :label="getItemTitle('Place of Discharge')"
              :title="$t('SeaExport.BillLadingPortOfDischarge')"
            >
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode || ''"
                tag-name="englishName"
                @parentCallBack="p => { portChange(p, 'dischargingPortCode', 'dischargingPort') }"
              />
              <el-input v-model="form.dischargingPort" disabled />
            </el-form-item>
            <el-form-item label="Berth Date" title="Berth Date">
              <el-date-picker
                v-model="form.berthDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                @change="$emit('syncThailandInfo', 'berthDate')"
              />
            </el-form-item>
            <el-form-item label="Shed Number/Release Port" title="Shed Number/Release Port">
              <el-input v-model="form.shedNumber" @change="$emit('syncThailandInfo', 'shedNumber')" />
            </el-form-item>
          </el-form>
        </div>
        <!--其他信息-->
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="left" style="height:100%">
            <span class="title" :title="$t('SeaExport.OtherInformation')">{{ getItemTitle('Other') }}</span>
            <el-form-item label-width="0" class="auto-width">
              <cargo-ag-grid
                :grid-options="masterInfo.gridOptions"
                :column-defs="masterInfo.columnDefs"
                :row-data="[{ jobNo: job.jobNo }]"
                :show-side-bar="false"
                style="width:100%;height:200px"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-ag-grid
                :grid-options="thailand2.gridOptions"
                :column-defs="thailand2ColumnDefs"
                :row-data="thailand2.rowData"
                style="width:100%;height:200px"
                @gridReady="params => { thailand2.gridApi = params.api }"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button
                    type="primary"
                    :title="$t('SeaExport.SynchronizeHBLInformation')"
                    @click="$emit('synchroThailandClickHandler')"
                  >{{ getItemTitle('Synchronise HB/L') }}</el-button>
                  <el-button
                    type="danger"
                    :title="$t('SeaExport.Delete')"
                    @click="$emit('removeCargoDoc')"
                  >{{ getItemTitle('Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="getItemTitle('Carrier SCAC')" :title="$t('SeaExport.ShippingCompanySCAC')">
              <el-input :disabled="true" :value="txtCarrierScAc" />
            </el-form-item>
            <el-form-item label="Ship Agent" title="Ship Agent">
              <cargo-company-select
                :method-params="{seaCmpAgent:true,active:true}"
                :default-value="form.shipAgent||''"
                @change="changeShipAgent"
              />
            </el-form-item>
            <el-form-item label="Ship Agent Tax No." title="Ship Agent Tax No.">
              <el-input v-model="form.shipAgentTaxNo" @change="$emit('syncThailandInfo', 'shipAgentTaxNo')" />
            </el-form-item>
            <el-form-item title="Cargo Movement" label="Cargo Movement">
              <el-select v-model="form.cargoMovement" :clearable="false" @change="$emit('syncThailandInfo', 'cargoMovement')">
                <el-option value="3" label="3. Transhipment" />
                <el-option value="4" label="4. Over side" />
                <el-option value="5" label="5. Consolidate" />
                <el-option value="6" label="6. Through Cargo" />
                <el-option value="7" label="7. Transit" />
                <el-option value="L" label="L. Intransit to LAOS" />
                <el-option value="O" label="O. OTHER" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="section">
      <span class="title" :title="$t('SeaExport.ContainerInformation')">{{ getItemTitle('House Container Information') }}</span>
      <div style="display:flex;flex-direction:column">
        <cargo-ag-grid
          config-module="130902"
          :grid-options="container.gridOptions"
          :column-defs="containerColumnDefs"
          :row-data="containerRowData"
          style="width:100%;height:350px"
          @gridReady="params => { container.gridApi = params.api }"
        />
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :warning-count="50"
        :disabled="readonly"
        style="height: 198px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="advanceTextDialog.visible = false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import ThailandAddressFormatForm from '@/views/cargo/v0/SeaExport/components/booking/ams/form/thailandAddressFormatForm.vue'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ThailandInfo',
  components: {
    ThailandAddressFormatForm, CargoRichTextarea, AutoNumberInput, cargoCompanySelect, cargoAdvanceSelect, cargoPackingSelect
  },
  props: {
    action: { type: String, required: true },
    thailand2: { type: Object, default: () => { } },
    container: { type: Object, default: () => { } },
    form: { type: Object, default: () => { } },
    job: { type: Object, default: () => { } },
    txtCarrierScAc: { type: String, default: '' },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      TYPE_NAMES,
      cargoTypeEnum: [
        { value: '1', label: '1. General' },
        { value: '2', label: '2. Dangerous' },
        { value: '7', label: '7. Reefer Cargo' }
      ],
      containerStatusEnum: [
        { value: '4', label: '4.MTY (Empty)' },
        { value: '7', label: '7.LCL (Less Container Load)' },
        { value: '8', label: '8.FCL (Full Container Load)' },
        { value: '9', label: '9.CFS (Container Freight Station)' }
      ],
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          maxChar: 45
        }
      },
      masterInfo: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: 'No.',
            field: 'jobNo',
            flex: 1
          }
        ]
      },
      isChineseLanguage: false
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    containerColumnDefs() {
      return [
        {
          headerName: this.getItemTitle('Container Size'),
          headerTooltip: this.$t('SeaExport.BoxModel'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 160,
          cellRenderer: (params) => {
            return params.value + '\''
          }
        }, {
          headerName: this.getItemTitle('Container Type'),
          headerTooltip: this.$t('SeaExport.BoxSpecies'),
          colId: 'eqType',
          field: 'eqType',
          width: 160
        }, {
          headerName: this.getItemTitle('Container No'),
          headerTooltip: this.$t('SeaExport.ContainerNumber'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 160
        }, {
          headerName: this.getItemTitle('Seal No'),
          headerTooltip: this.$t('SeaExport.SealNumber'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 160
        }, {
          headerName: this.isChineseLanguage ? '件数' : 'Quantity',
          headerTooltip: this.$t('SeaExport.itemCount'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        }, {
          headerName: this.getItemTitle('Unit Type'),
          headerTooltip: this.$t('SeaExport.Packing'),
          colId: 'packing',
          field: 'packing',
          width: 160,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', this.form.packing, 'name')
          }
        }, {
          headerName: this.getItemTitle('Gross Weight'),
          headerTooltip: this.$t('SeaExport.GrossWeight'),
          colId: 'weight',
          field: 'weight',
          width: 160,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        }, {
          headerName: this.getItemTitle('Volume'),
          headerTooltip: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 160,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              }
            },
            valueChanged: p => {
              this.packageInfoChanged(p)
            }
          }
        },
        {
          headerName: this.getItemTitle('Goods'),
          headerTooltip: this.$t('SeaExport.CommodityName'),
          colId: 'cargoName',
          field: 'cargoName',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Goods')
          }
        },
        {
          headerName: this.getItemTitle('Marks'),
          headerTooltip: this.$t('SeaExport.ShippingMark'),
          colId: 'mark',
          field: 'mark',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Marks')
          }
        },
        {
          headerName: this.getItemTitle('HS CODE'),
          headerTooltip: this.$t('SeaExport.HsCode'),
          colId: 'hsCodeContainer',
          field: 'hsCodeContainer',
          width: 80,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => {
            this.hsCodeChanged(params)
          }
        },
        {
          headerName: 'Goods Cargo Type',
          field: 'goodsCargoType',
          width: 150,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          valueFormatter: (params) => {
            const cargoType = this.cargoTypeEnum.find(p => p.value === params.value)
            return cargoType ? cargoType.label : ''
          },
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: this.cargoTypeEnum,
            tagName: 'label',
            tagValue: 'value'
          }
        },
        {
          headerName: 'UNDG Number',
          field: 'undgNumber',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: 'IMO Class',
          field: 'imoClass',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: 'Container Status',
          field: 'containerStatus',
          width: 150,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          valueFormatter: (params) => {
            const containerStatus = this.containerStatusEnum.find(p => p.value === params.value)
            return containerStatus ? containerStatus.label : ''
          },
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: this.containerStatusEnum,
            tagName: 'label',
            tagValue: 'value'
          }
        }
      ]
    },
    containerRowData() {
      return this.container.rowData.filter(p => !p.deleted)
    },
    thailand2ColumnDefs() {
      return [
        {
          headerName: 'Job No',
          colId: 'jobNo',
          field: 'jobNo',
          flex: 1,
          width: 260
        }, {
          headerName: 'HB/L',
          colId: 'hblNbr2',
          field: 'hblNbr2',
          flex: 1,
          width: 260
        }, {
          headerName: 'Last',
          colId: 'afrLast',
          field: 'afrLast',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox',
            valueChanged: params => {
              for (const row of this.thailand2.rowData) {
                row.afrLast = row === params.data
              }
              this.thailand2.gridOptions.api.refreshCells({ force: true })
            }
          }
        }
      ]
    },
    afrAddress() {
      if (this.form.afrAddress && this.form.afrAddress.length > 0) {
        return this.form.afrAddress[0]
      }
      return new AfrAddress().fillDefaultValue().getData()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isChineseLanguage = Number(cache.config.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
  },
  methods: {
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    packageInfoChanged(params) {
      if (this.form.docType === CargoDocConsts.THAILAND) {
        let sum = 0
        for (const item of this.container.rowData) {
          if (item.deleted) {
            continue
          }
          sum += Number(item[params.field])
        }
        this.form[params.field] = sum
      }
    },
    hsCodeChanged(params) {
      for (const item of this.container.rowData) {
        if (item.deleted) {
          continue
        }
        item.hsCodeContainer = params.newValue
      }
      if (this.form.docType === CargoDocConsts.THAILAND) {
        this.form.hsCode = params.newValue
      }
      this.container.gridOptions.api.refreshCells({ force: true })
    },
    hblNbr2Change() {
      const gridApi = this.thailand2.gridApi
      gridApi.refreshCells()
    },
    portChange(p, portCodeField, portNameField) {
      const form = this.form
      form[portCodeField] = p.value
      form[portNameField] = p.value
      this.$emit('syncThailandInfo', portCodeField)
      this.$emit('syncThailandInfo', portNameField)
    },
    showSenderAndReceiverDialog(type, value, callback) {
      switch (type) {
        case 'shipper':
          this.advanceTextDialog.title = this.$t('SeaExport.Shipper')
          break
        case 'consignee':
          this.advanceTextDialog.title = this.$t('SeaExport.Consignee')
          break
        case 'notify':
          this.advanceTextDialog.title = this.$t('SeaExport.Notifier')
          break
      }
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = () => { callback(this.advanceTextDialog.value) }
      this.advanceTextDialog.visible = true
    },
    changeUnitType(p) {
      this.form.packing = p.value
      this.container.gridOptions.api.clearFocusedCell()
      this.container.gridOptions.api.refreshCells({ force: true })
    },
    changeVoyage() {
      this.form.voyageFlight = CargoDocUtil.replaceVoyage(this.form.voyageFlight, true)
      for (const row of this.thailand2.rowData) {
        if (row === this.form) {
          this.$emit('syncThailandInfo', 'voyageFlight')
          break
        }
      }
    },
    async changeShipAgent(data) {
      this.form.shipAgent = data.value
      if (this.form.shipAgent) {
        await queryTitleByCpmIdx(this.form.shipAgent).then(res => {
          if (res.data && res.data.length > 0) {
            for (const item of res.data) {
              if (item.defaultTitle) {
                this.form.shipAgentTaxNo = item.taxAccount
              }
            }
          }
        })
      }
      this.$emit('syncThailandInfo', 'shipAgent')
      this.$emit('syncThailandInfo', 'shipAgentTaxNo')
    },
    changeContainerStatus() {
      for (const row of this.container.rowData) {
        row.containerStatus = this.form.containerStatus
      }
      this.container.gridOptions.api.refreshCells({ force: true })
    },
    changeCargoType() {
      for (const row of this.container.rowData) {
        row.goodsCargoType = this.form.docCargoType
      }
      this.container.gridOptions.api.refreshCells({ force: true })
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    }
  }
}
</script>

<style lang="scss">
.thailand-info {
  .warning .el-input__inner {
    color: red !important;
  }
  .warning {
    color: red !important;
  }
  .el-radio__label {
    font-size: 12px;
    font-weight: normal;
    color: #333333 !important;
  }
  .el-checkbox__label {
    font-weight: normal;
    color: #333333 !important;
  }
  .el-form-item__label {
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
